import { useState } from "react";
import axios from "axios";
import { Sparkles, Loader2, ChevronDown, ChevronUp } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CONFIDENCE_LABEL = {
  A_EXAMINER: "À examiner",
  INFORMATION_INSUFFISANTE: "Information insuffisante",
  CONTRADICTION_A_VERIFIER: "Contradiction à vérifier",
};

export default function SuggestionCard({ analysisId, s, onDecided }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const decided = !!s.DECISION_UTILISATEUR;

  const decide = async (decision) => {
    setBusy(true);
    try {
      await axios.put(`${API}/hfacs/${analysisId}/suggestions/${s.ID_SUGGESTION}`, { decision });
      onDecided();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid={`suggestion-card-${s.ID_SUGGESTION}`} className="bg-card border border-cyan-500/40 rounded-md p-4">
      <div className="flex items-center justify-between mb-2">
        <span className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase px-2 py-0.5 rounded-sm border border-cyan-500/30 bg-cyan-500/10 text-cyan-700">
          <Sparkles className="h-3 w-3" /> {s.NIVEAU_HFACS}
        </span>
        <span className="font-mono text-[10px] uppercase px-2 py-0.5 rounded-sm border border-border text-muted-foreground">
          {decided ? s.STATUT : (CONFIDENCE_LABEL[s.TYPE_SUGGESTION] || s.TYPE_SUGGESTION)}
        </span>
      </div>
      <p className="text-sm font-medium mb-1">Facteur suggéré : {s.ID_FACTEUR_PROPOSE}</p>
      <p className="text-sm text-muted-foreground mb-2">{s.JUSTIFICATION_IA}</p>

      <button onClick={() => setOpen(!open)} data-testid={`suggestion-why-toggle-${s.ID_SUGGESTION}`} className="text-xs text-accent flex items-center gap-1 mb-2">
        Pourquoi ? {open ? <ChevronUp className="h-3 w-3" /> : <ChevronDown className="h-3 w-3" />}
      </button>
      {open && (
        <div className="text-xs text-muted-foreground space-y-2 mb-3 border-t border-border pt-2">
          <p><span className="text-foreground">Faits utilisés :</span> {s.ID_FAIT || "—"}</p>
          {s.INFORMATIONS_MANQUANTES && <p><span className="text-foreground">Informations manquantes :</span> {s.INFORMATIONS_MANQUANTES}</p>}
          {s.QUESTIONS_PROPOSEES && <p><span className="text-foreground">Questions recommandées :</span> {s.QUESTIONS_PROPOSEES}</p>}
        </div>
      )}

      {decided ? (
        <p className="text-xs font-mono uppercase text-muted-foreground">Décision : {s.STATUT}</p>
      ) : (
        <div className="flex gap-2">
          <button disabled={busy} onClick={() => decide("INVESTIGUER")} data-testid={`suggestion-investigate-${s.ID_SUGGESTION}`} className="bg-cyan-600 hover:bg-cyan-500 text-white font-medium text-xs px-3 py-1.5 rounded-sm disabled:opacity-50">
            {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : "Investiguer"}
          </button>
          <button disabled={busy} onClick={() => decide("ECARTER")} data-testid={`suggestion-discard-${s.ID_SUGGESTION}`} className="bg-slate-100 hover:bg-slate-200 text-slate-700 font-medium text-xs px-3 py-1.5 rounded-sm border border-slate-300 disabled:opacity-50">
            Écarter
          </button>
          <button disabled={busy} onClick={() => decide("PLUS_TARD")} data-testid={`suggestion-later-${s.ID_SUGGESTION}`} className="text-slate-600 hover:text-slate-800 text-xs px-2 py-1.5 disabled:opacity-50">
            Plus tard
          </button>
        </div>
      )}
    </div>
  );
}
